module.exports = __webpack_public_path__ + "static/media/folks.0b2697c7.png";